import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useCallback, useEffect, useState } from 'react';
import { FixTextButton } from './FixTextButton';

type SaveAssetDialogNameInputProps = {
  label: string;
  assetName: string;
  onBlur: (name: string) => void;
  helperText?: string;
  showFixButton?: boolean;
  onFix: () => void;
};

export function SaveAssetDialogNameInput({ label, assetName, onBlur, helperText, showFixButton, onFix }: SaveAssetDialogNameInputProps) {
  const [value, setValue] = useState(assetName);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;

      setValue(newValue);

      if (newValue === '') {
        onBlur('');
      }
    },
    [onBlur]
  );

  useEffect(() => {
    setValue(assetName);
  }, [assetName]);

  return (
    <TextField
      fullWidth
      label={label}
      sx={{
        marginY: '0.5rem',
        '& .MuiInputBase-input': {
          paddingLeft: '0.75rem',
          paddingRight: '0.75rem',
        },
      }}
      value={value}
      onChange={handleChange}
      onBlur={() => onBlur(value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' && value.length > 0) {
          onBlur(value);
        }
      }}
      inputProps={{
        onClick: () => {
          // Override src/muiTheme/MuiOutlinedInput.ts click handler to prevent text selection
        },
      }}
      error={helperText !== undefined}
      helperText={
        helperText && (
          <Typography variant="caption" component="span" data-testid="snippet-error-text">
            {helperText}
            {showFixButton && (
              <>
                &nbsp;
                <FixTextButton handleFix={onFix} />
              </>
            )}
          </Typography>
        )
      }
      type="text"
    />
  );
}
